import { createAction, props } from '@ngrx/store';
import {
  WasteCollectionAreaAppEntityWasteWasteCollectionAreaRead,
  WasteCollectionAreaAppEntityWasteWasteNotificationSubscriptionItemRead,
  WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead
} from '../../openapi';

export const loadCollection = createAction(
  '[Municipal waste] load collection',
  props<{ force?: boolean }>()
);

export const loadCollectionSuccess = createAction(
  '[Municipal waste] load collection success',
  props<{ collection: WasteCollectionAreaAppEntityWasteWasteCollectionAreaRead[] }>()
);

export const loadCollectionFailure = createAction(
  '[Municipal waste] load collection failure'
);

export const loadScheduleEntries = createAction(
  '[Municipal waste] load schedule entries',
  props<{ areaId: string }>()
);

export const loadScheduleEntriesSuccess = createAction(
  '[Municipal waste] load schedule entries success',
  props<{ scheduleCollection: WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead[] }>()
);

export const loadScheduleEntriesFailure = createAction(
  '[Municipal waste] load schedule entries failure'
);
